module.exports = __webpack_public_path__ + "img/icon-pinterest.fbdf1e75.svg";